import { useState } from 'react';
import { squaredToValue } from '../lib/helpers';

export const useSynthControls = (sendCommand) => {
    // Main gain control (default 0.8)
    const [gainSlider, setGainSlider] = useState(Math.sqrt(0.8));

    // Source controls
    const [sourceType, setSourceType] = useState('WAVE');
    const [waveform, setWaveform] = useState('SAW');
    const [harmonicPreset, setHarmonicPreset] = useState('SAW');

    // Handlers
    const handleGainChange = (sliderPos) => {
        setGainSlider(sliderPos);
        const actualValue = squaredToValue(sliderPos, 0, 1);
        sendCommand('synth.gain', actualValue.toFixed(3));
    };

    const handleSourceTypeChange = (type) => {
        setSourceType(type);
        sendCommand('synth.source', type);
    };

    const handleWaveformChange = (wf) => {
        setWaveform(wf);
        sendCommand('synth.waveform', wf);
    };

    const handleHarmonicPresetChange = (preset) => {
        setHarmonicPreset(preset);
        sendCommand('synth.harmonic', preset);
    };

    // Computed actual values
    const gainActual = squaredToValue(gainSlider, 0, 1);

    return {
        // Values
        gainSlider,
        gainActual,
        sourceType,
        waveform,
        harmonicPreset,
        
        // Handlers
        handleGainChange,
        handleSourceTypeChange,
        handleWaveformChange,
        handleHarmonicPresetChange
    };
};